import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const TasksIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Tasks",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.68 20.52c-1.12-2.26-1.78-4.91-1.78-7.72V5.7c0-.13-.02-.26-.06-.37-.31-1.54-1.65-2.7-3.27-2.7H5.33c-1.61 0-2.96 1.16-3.26 2.68v.02q-.06.165-.06.36v7.09c0 3.74 1.02 7.25 2.81 10.25l-.05-.09c.84 1.4 2.34 2.32 4.06 2.34h16.65v.74c0 .51-.41.91-.91.91H5.33c-.51 0-.91-.41-.91-.91 0-.67-.54-1.21-1.21-1.21S2 25.35 2 26.02c0 1.84 1.49 3.33 3.33 3.33h19.23c1.84 0 3.33-1.49 3.33-3.33V25c.68-.27 1.23-.74 1.6-1.33.31-.51.5-1.11.5-1.75 0-.52-.12-1-.33-1.44v.02Zm-22.82 1.2c-1.53-2.56-2.43-5.65-2.43-8.95v-1.62h21.05v1.63c0 3.2.75 6.23 2.09 8.92l-.05-.12c.07.12.11.27.11.43s-.04.3-.11.43c-.16.26-.45.43-.78.43H8.87c-.85 0-1.6-.46-2.01-1.14s0-.01 0-.01"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.29 6.43H14.43a1.14 1.14 0 1 1 0-2.28h14.86a1.14 1.14 0 1 1 0 2.28M29.29 16.71H14.43a1.14 1.14 0 1 1 0-2.28h14.86a1.14 1.14 0 1 1 0 2.28M29.29 27H14.43a1.14 1.14 0 1 1 0-2.28h14.86a1.14 1.14 0 1 1 0 2.28M8.71 19H4.14C3.51 19 3 18.49 3 17.86v-4.57c0-.63.51-1.14 1.14-1.14h4.57c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14m-3.42-2.29h2.29v-2.29H5.29zM8.71 29.28H4.14c-.63 0-1.14-.51-1.14-1.14v-4.57c0-.63.51-1.14 1.14-1.14h4.57c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14M5.29 27h2.29v-2.29H5.29zM5.29 8.71c-.3 0-.59-.12-.81-.33L2.19 6.09a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l1.48 1.48 3.76-3.76a1.15 1.15 0 0 1 1.62 0c.45.45.45 1.17 0 1.62L6.1 8.38c-.21.21-.51.33-.81.33"
      })
    })
  }));
};